import { StructureColumn } from "./structureColumn";


export class StructureColumn3 {
    defaultOptions = {
        wrapperClass: 'structure__content',
        slideClass: 'card-news',
        spaceBetween: 1,
        slidesPerView: 3,
        slidesPerColumn: 1,
        slidesPerGroup: 3,
        initialSlide: 0,
        breakpoints: {
            740: {
                slidesPerView: 2,
                slidesPerColumn: 2,
                slidesPerGroup: 2
            }
        },
        navigation: {
            prevEl: '.pagination-control__navigation--prev',
            nextEl: '.pagination-control__navigation--next'
        },
        slideClassHidden: '.card-news'
    };

    slidesPerView = 3;

    structureClass = '.structure--col-3';

    constructor() {
        this.init();
    }

    init() {
        new StructureColumn(this.defaultOptions, this.slidesPerView, this.structureClass);
    }
}
